<script>
    export default {
        methods: {
            handleCurrentChange(e) {
                this.$router.push({
                    path: this.pageUrl,
                    query: {
                        ...this.$route.query,
                        page: e
                    }
                });
            },
            handleSizeChange(e) {
                this.$router.push({
                    path: this.pageUrl,
                    query: {
                        ...this.$route.query,
                        per_page: e
                    }
                })
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/mixins/PaginationChange.vue